/* eslint-disable jira/filename-case */
import { useEffect } from 'react';
import {
	fireOperationalAnalytics,
	useAnalyticsEvents,
	type UIAnalyticsEvent,
} from '@atlassian/jira-product-analytics-bridge';

// eslint-disable-next-line no-restricted-properties, jira/jira-ssr/no-unchecked-globals-usage
const getNow = (): number => window?.performance?.now?.();

class SearchLoadOnIntentMetric {
	hasFired = false;

	startTime: number | null = null;

	stopTime: number | null = null;

	isStartFromSkeleton = false;

	start(isStartFromSkeleton: boolean, startTime: number = getNow()): void {
		if (this.startTime !== null) {
			return;
		}
		this.isStartFromSkeleton = isStartFromSkeleton;
		this.startTime = startTime;
	}

	stop(analyticsEvent: UIAnalyticsEvent, endTime: number = getNow()): void {
		if (this.startTime === null || this.stopTime !== null || this.hasFired) {
			return;
		}
		this.stopTime = endTime;
		fireOperationalAnalytics(analyticsEvent, 'searchDialog firstOpen', {
			startTime: Math.round(this.startTime),
			duration: Math.round((this.stopTime || 0) - (this.startTime || 0)),
			isStartFromSkeleton: this.isStartFromSkeleton,
		});
		this.hasFired = true;
	}
}

let searchLoadOnIntentMetric = new SearchLoadOnIntentMetric();

// Exported for testing purposes
export const getSearchLoadOnIntentMetric = (): SearchLoadOnIntentMetric => searchLoadOnIntentMetric;

// For testing purposes, we can reset the metric instance
export const resetSearchLoadOnIntentMetric = (): void => {
	searchLoadOnIntentMetric = new SearchLoadOnIntentMetric();
};

export const searchLoadOnIntentMetricStartFromSkeleton = (startTime?: number): void => {
	searchLoadOnIntentMetric.start(true, startTime);
};

export const SearchLoadOnIntentMetricEnd = ({ endTime }: { endTime?: number }): null => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	useEffect(() => {
		searchLoadOnIntentMetric.stop(createAnalyticsEvent({}), endTime);
	}, [createAnalyticsEvent, endTime]);

	return null;
};

export const searchLoadOnIntentMetricFromSearchFire = (
	analyticsEvent: UIAnalyticsEvent,
	now: number = getNow(),
): void => {
	if (searchLoadOnIntentMetric.hasFired || searchLoadOnIntentMetric.startTime !== null) {
		return;
	}
	searchLoadOnIntentMetric.start(false, now);
	searchLoadOnIntentMetric.stop(analyticsEvent, now);
};
